import React from 'react'
import { useApp } from '../context/AppContext'

export function Profile() {
  const { state, dispatch } = useApp()
  const currentUser = state.users.find(u => u.id === state.currentUserId)
  const myCharacters = state.characters.filter(c => c.userId === state.currentUserId)

  const handleSignOut = () => {
    dispatch({ type: 'SET_CURRENT_USER', payload: null })
  }

  const handleDeleteAccount = () => {
    if (confirm('Delete your account and all data? This cannot be undone.')) {
      dispatch({ type: 'SET_USERS', payload: state.users.filter(u => u.id !== state.currentUserId) })
      dispatch({ type: 'SET_CHARACTERS', payload: state.characters.filter(c => c.userId !== state.currentUserId) })
      dispatch({ type: 'SET_CURRENT_USER', payload: null })
    }
  }

  if (!currentUser) {
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl font-bold mb-4">Not Signed In</h2>
        <p className="text-gray-400">Sign in to view your profile</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <h1 className="text-3xl font-bold">Profile</h1>

      {/* Profile Card */}
      <div className="bg-gradient-to-br from-white/10 to-white/5 border border-white/10 rounded-2xl p-6">
        <div className="flex items-start gap-6">
          <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-cyan-500 to-purple-600 flex items-center justify-center text-4xl font-black">
            {currentUser.name?.[0]?.toUpperCase() || '?'}
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold">{currentUser.name || 'Unknown'}</h2>
            <p className="text-gray-400">{currentUser.tag || currentUser.name || 'No tagline'}</p>
            <div className="flex gap-4 mt-4 text-sm">
              <div className="px-3 py-1 bg-white/5 rounded-lg">
                <span className="text-gray-500">Member since</span>
                <span className="ml-2">
                  {currentUser.createdAt ? new Date(currentUser.createdAt).toLocaleDateString() : 'Unknown'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
          <div className="text-3xl font-bold text-cyan-400">{myCharacters.length}</div>
          <div className="text-sm text-gray-500">Fighters</div>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
          <div className="text-3xl font-bold text-purple-400">{state.matchHistory.length}</div>
          <div className="text-sm text-gray-500">Matches</div>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
          <div className="text-3xl font-bold text-green-400">
            {state.matchHistory.filter(m => m.winner === 'player').length}
          </div>
          <div className="text-sm text-gray-500">Wins</div>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
          <div className="text-3xl font-bold text-amber-400">
            {state.tournaments.filter(t => t.createdBy === state.currentUserId).length}
          </div>
          <div className="text-sm text-gray-500">Tournaments</div>
        </div>
      </div>

      {/* Recent Matches */}
      {state.matchHistory.length > 0 && (
        <div className="bg-white/5 border border-white/10 rounded-xl p-6">
          <h3 className="text-lg font-bold mb-4">Recent Matches</h3>
          <div className="space-y-2">
            {state.matchHistory.slice(0, 5).map((match, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-black/30 rounded-lg">
                <div className="flex items-center gap-3">
                  <span className={match.winner === 'player' ? 'text-green-400' : 'text-red-400'}>
                    {match.winner === 'player' ? 'Victory' : 'Defeat'}
                  </span>
                  <span className="text-gray-500">vs</span>
                  <span>{match.opponent}</span>
                </div>
                <span className="text-sm text-gray-500">
                  {new Date(match.date).toLocaleDateString()}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Actions */}
      <div className="flex gap-4">
        <button
          onClick={handleSignOut}
          className="px-4 py-2 bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 transition-all"
        >
          Sign Out
        </button>
        <button
          onClick={handleDeleteAccount}
          className="px-4 py-2 bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg hover:bg-red-500/20 transition-all"
        >
          Delete Account
        </button>
      </div>
    </div>
  )
}
